import { Button } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

/**
 * Back link to a parent hub. Defaults to the Compliance Overview (where Audit
 * log / Data extraction / Change requests are reached from). The Admin-housed
 * pages — Users / Permissions / SAA reference / Standard & Compute fees — pass
 * `to="/admin"` + `label="Back to Admin"` (2026-06-21 nav reorg).
 */
export function BackToCompliance(
  { to = '/compliance', label = 'Back to Compliance' }: { to?: string; label?: string } = {},
) {
  return (
    <Button
      component={Link}
      to={to}
      variant="subtle"
      size="xs"
      px={0}
      leftSection={<IconArrowLeft size={14} />}
      style={{ alignSelf: 'flex-start' }}
    >
      {label}
    </Button>
  );
}
